import React from 'react';
import styled from 'styled-components';
import './footer.css'

const FooterContendor  = styled.div`
    background-color: #ffffff2e;
    margin-top: 50px;
`;

const Footer = () => {
    return ( 
        <FooterContendor>

            <footer className="footer-distributed">

                <div className="footer-right">

                    <a href="https://api.whatsapp.com/send?phone=9981147422&text=Hola,%20nos%20gustaria%20contactarte%20" target="_blank" rel="noopener noreferrer"><i className="fa fa-whatsapp"></i></a>
                    <a href="https://www.linkedin.com/in/gean-carlo-vitorino-monjaras-a7346811a/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin"></i></a>
                    <a href="https://github.com/GeanCarloV" target="_blank" rel="noopener noreferrer"><i className="fa fa-github"></i></a>
                    <a href="#!"><i className="fa fa-medium"></i></a>
                    
                </div>

                <div className="footer-left">

                    <p className="footer-links">
                        <a href="https://www.linkedin.com/in/gean-carlo-vitorino-monjaras-a7346811a/" target="_blank" rel="noopener noreferrer">Home</a>

                        <a href="https://www.linkedin.com/in/gean-carlo-vitorino-monjaras-a7346811a/" target="_blank" rel="noopener noreferrer">About</a>

                        <a href="https://app.netlify.com/teams/geancarlov/sites" target="_blank" rel="noopener noreferrer">Proyectos</a>

                        <a href="mailto:gean.carlo.vitorino@gmail.com" target="_blank" rel="noopener noreferrer">Email</a>
                    </p>

                    <p>Gean Carlo Vitorino &copy; 2018  -  gean.carlo.vitorino@gmail.com </p>
                </div>

            </footer>
        </FooterContendor>
     );
}
 
export default Footer;